<template>
  <div class="home">
    <div class="topBox" :style="{ 'width': sign ? '1920px' : '100%'}">
      <div class="ydlogoBox"><img src="../assets/ydguanwang/ydlogo.png" class="ydlogoImg" alt=""></div>
      <div class="elmenuBox">
        <el-menu :default-active="activeIndex" text-color="black" active-text-color="#122C89" class="el-menu-demo"
          mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">首页</el-menu-item>
          <el-submenu index="2">
            <template slot="title">产品及工具</template>
            <el-menu-item index="2-0">职业性格测评TCPA</el-menu-item>
            <el-menu-item index="2-1">职业驱动力测评TCMA</el-menu-item>
            <el-menu-item index="2-2">心理健康测评TMHA</el-menu-item>
            <el-menu-item index="2-3">任职风险测评TERA</el-menu-item>
            <el-menu-item index="2-4">认知能力测评TCCA</el-menu-item>
            <el-menu-item index="2-5">情境模拟测试TSSA</el-menu-item>
            <el-menu-item index="2-6">360多源反馈工具</el-menu-item>
          </el-submenu>
          <el-menu-item index="3">人才盘点</el-menu-item>
          <el-submenu class="el-menu-demo" index="4">
    <template slot="title">人才培养</template>
    <div class="submenu-items">
      <el-menu-item style="text-align:left;border:1px solid transparent;margin-right:60px" :index="item.courseId" v-for="(item, index) in courseList" :key="index">{{ item.courseName }}</el-menu-item>
    </div>
  </el-submenu>
          <el-menu-item index="6">系统建设</el-menu-item>
          <el-submenu index="7">

            <template slot="title">关于我们</template>
            <el-menu-item index="7-1">关于我们</el-menu-item>
            <el-menu-item index="7-2">加入我们</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="phoneBox">
        <div class="phoneItem">
          <img src="../assets/ydguanwang/phonelogo.png" class="phoneImg" alt="">
        </div>
        <div class="zixunrexian">咨询热线: <span class="haoma">400-881-1102</span> </div>
        <div class="loginbutton" @click="goLoginSystem">登录</div>

      </div>
    </div>
    <div class="tuceng" :style="{ 'width': sign ? '1920px' : '100%'}">
      <img src="../assets/ydguanwang/xinshouye.jpg" class="tucengimg" alt="">
      <!-- <div class="yuyuebtn">预约了解</div> -->
    </div>
    <div class="centerBox" :style="{ 'width': sign ? '1920px' : '100%'}">
      <div class="cpandgjBox">
        <div class="cpTitle">产品及工具</div>
        <div class="cpmiaoshu">

          <img src="../assets/ydguanwang/lineleft.png" class="lineleft" alt="">


          <div>基于平台系统和数据观点，为您提供人才供应链全流程解决方案</div>
          <img src="../assets/ydguanwang/lineright.png" class="lineleft" alt="">
        </div>
        <div class="cpBox">
          <div class="cpItem">
            <img src="../assets/ydguanwang/xiaoyuan.png" class="cpImg" alt="">
            <div class="cpname">校园招聘</div>
            <div class="cpdetail" @click="gotoDetail">
              <div>了解详情</div>
              <img src="../assets/ydguanwang/xiaoyuanjiantou.png" class="jiantouImg" alt="">
            </div>
          </div>
          <div class="cpItem">
            <img src="../assets/ydguanwang/shehui.png" class="cpImg" alt="">
            <div class="cpname">社会招聘</div>
            <div class="cpdetail" style="border: 2px solid #5C7FFA;color: #5C7FFA;" @click="gotoDetail">
              <div>了解详情</div>
              <img src="../assets/ydguanwang/shehuijiantou.png" class="jiantouImg" alt="">
            </div>
          </div>
          <div class="cpItem">
            <img src="../assets/ydguanwang/neibu.png" class="cpImg" alt="">
            <div class="cpname">内部竞聘</div>
            <div class="cpdetail" style="border: 2px solid #F4A72C;color: #F4A72C;" @click="gotoDetail">
              <div>了解详情</div>
              <img src="../assets/ydguanwang/neibujiantou.png" class="jiantouImg" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="carouselBox">
        <el-carousel :loop="false" :autoplay="false" class="carousel">
          <el-carousel-item class="el-car-item" v-for="(list, index) in dataList" :key="index">
            <div v-for="(imgList, index1) in list" :key="index1" class="divSrc">

              <div class="img" :style="{ 'background': imgList.color }">
                <img src="../assets/ydicon/xinggeicon.png" v-show="imgList.id == '2-0'" style="width:50px;height:60px"  class="iconImg" alt="">
                <img src="../assets/ydicon/qudongliicon.png" v-show="imgList.id == '2-1'" style="width:57px;height:60px" class="iconImg" alt="">
                <img src="../assets/ydicon/xinicon.png" v-show="imgList.id == '2-2'" style="width:59px;height:59px"  class="iconImg" alt="">
                <img src="../assets/ydicon/fengxianicon.png" v-show="imgList.id == '2-3'" style="width:53px;height:60px"  class="iconImg" alt="">
                <img src="../assets/ydicon/qingjingicon.png" v-show="imgList.id == '2-5'" style="width:58px;height:60px"  class="iconImg" alt="">
                <img src="../assets/ydicon/renzhinengicon.png" v-show="imgList.id == '2-4'" style="width:51px;height:61px"  class="iconImg" alt="">
                <img src="../assets/ydicon/360icon.png" v-show="imgList.id == '2-6'" style="width:61px;height:59px"  class="iconImg" alt="">
                
              </div>
              <div class="title">{{ imgList.title }}</div>
              <div class="describle">{{ imgList.describle }}</div>
              <div class="gongjudetail" @click="goDetailTool(imgList.id)">
                <div>了解详情</div>
                <img src="../assets/ydguanwang/gongjuright.png" class="gongjuright" alt="">

              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="pandianBox" :style="{ 'width': sign ? '1920px' : '100%'}">
      <div class="banxinbox">
        <div class="cpTitle">人才盘点</div>
        <div class="cpmiaoshu">

          <img src="../assets/ydguanwang/lineleft.png" class="lineleft" alt="">


          <div>企业前20%的员工贡献了80%的产出！必须找出这些宝贵的人才！</div>
          <img src="../assets/ydguanwang/lineright.png" class="lineleft" alt="">
        </div>
        <div class="pandianItem">
          <div class="pandianxiang">
            <img src="../assets/ydguanwang/moxinggoujian.png" class="pandianImg" alt="">
            <div class="pandianTitle">能力素质模型构建</div>
          </div>
          <div class="pandianxiang">
            <img src="../assets/ydguanwang/pandianshishi.png" class="pandianImg" alt="">
            <div class="pandianTitle">盘点实施</div>
          </div>
          <div class="pandianxiang">
            <img src="../assets/ydguanwang/jiaozhun.png" class="pandianImg" alt="">
            <div class="pandianTitle">校准</div>
          </div>
          <div class="pandianxiang">
            <img src="../assets/ydguanwang/huibao.png" class="pandianImg" alt="">
            <div class="pandianTitle">汇报</div>
          </div>

        </div>
      </div>


    </div>
    <div class="centerBox" :style="{ 'width': sign ? '1920px' : '100%'}">
      <div class="cpandgjBox">
        <div class="cpTitle">未来有道 关于我们</div>
        <div class="cpmiaoshu">
          <img src="../assets/ydguanwang/lineleft.png" class="lineleft" alt="">
          <div>快一步人才发展理念践行者</div>
          <img src="../assets/ydguanwang/lineright.png" class="lineleft" alt="">
        </div>
        <div class="zizhiBox">
          <img src="../assets/ydguanwang/weilaiImg.png" class="weilaiImg" alt="">
          <div class="zizhiright">
            <div class="dizhi">公司分布：北京・西安・武汉・南京・重庆・青岛・昆明</div>
            <div class="jutijieshao">北京未来有道人才科技股份有限公司成立于2022年9月，总部设立于北京，目前已在南京、
              西安、武汉、重庆开设分支机构。</div>
            <div class="jutijieshao">基于AI TPS线上系统人才管理系统，通过匹配客户核心需求及使用场景，为客户提供人才招
              聘、人才测评、人才盘点、人才发展培养、人才库建设、人效管理、薪酬绩效管理等“快一
              步”人才发展解决方案。</div>
            <div class="jutijieshao">通过HR SaaS及私有化部署等场景，满足客户日常人才管理系统需要。</div>
          </div>

        </div>

      </div>

    </div>
    <div class="bottomBox" :style="{ 'width': sign ? '1920px' : '100%'}">
      <div class="bottombanxin">
        <div class="bottomLeft">
          <div>
            <img src="../assets/ydguanwang/talenpath.png" class="talenpath" alt="">
          </div>
          <div>
            <img src="../assets/ydguanwang/erweima.png" class="erweima" alt="">
          </div>
          <div class="guanzhu">扫码关注公众号</div>
        </div>

        <div class="bottomCenter">
          <div class="cepinggongju">测评工具</div>
          <div class="gongjuDeBox">
            <div class="deItem">职业性格TCPA</div>
            <div class="deItem">职业驱动力测评TCMA</div>
            <div class="deItem">心理健康测评TMHA</div>
            <div class="deItem">任职风险测评TERA</div>
            <div class="deItem">情境模拟测试TSSA</div>
            <div class="deItem">认知能力测评TCCA</div>
            <div class="deItem">360多源反馈工具</div>
          </div>
        </div>

        <div class="bottomRight">
          <div class="cepinggongju">咨询热线</div>
          <div class="dianhuahaoma">400-881-1102</div>
          <div class="cepinggongju" style="margin-top: 42px;">邮箱</div>
          <div class="youxiang">weilaiyoudao@talenpath.com</div>

        </div>

      </div>
      <div class="beianBox">
        ©2024 Talenpath All Rights Reserved  
        <a v-bind:href="link" style="color: white;"  target="_blank">京ICP备2023030182号-1</a> 
        未来有道版权所有
      </div>
    </div>



    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'HomeView',
  components: {

  },
  data() {
    return {
      link: "https://beian.miit.gov.cn/",
      dataList: [],
      activeIndex: '1',
      activeIndex2: '1',
      courseList: [{ courseId: '4-01', courseName: '01. 影响力核能—赢得人心的沟通法则' },
      { courseId: '4-02', courseName: '02. 拥抱变革—从所知到所行' },
      { courseId: '4-03', courseName: '03. 化怒为喜—有效处理客户投' },
      { courseId: '4-04', courseName: '04.职场精英的高效工作法则' },
      { courseId: '4-05', courseName: '05.人脉建构有效的职场进阶' },
      { courseId: '4-06', courseName: '06.个人领导力一领导者蜕变'},
      { courseId: '4-07', courseName: '07.管理者角色定位与职业化修饰' },
      { courseId: '4-08', courseName: '08.激活领导者胜出密码' },
      { courseId: '4-09', courseName: '09.知心艺语一管理者卓越辅导技T5' },
      { courseId: '4-10', courseName: '10.管理者赢得业绩的决策法则' },
      { courseId: '4-11', courseName: '11.赋能管理一卓越团队管理与建立' },
      { courseId: '4-12', courseName: '12.如何达成目标一目标与计划管理' },
      { courseId: '4-13', courseName: '13.商业思维助力职场跃迁' },
      { courseId: '4-14', courseName: '14.结构化表达一想清楚，说明白，赢赞赏' },
      { courseId: '4-15', courseName: '15.授权一激活团队的潜力' },
      { courseId: '4-16', courseName: '16.引爆执行力一管理执行力提升训练' },
      { courseId: '4-17', courseName: '17.我的情绪我做主一情绪与压力管理' },
      { courseId: '4-18', courseName: '18.时间管理一职场人士的第五代时间管理课' },
      { courseId: '4-19', courseName: '19.从偏方到处方一问题分析与解决' },
      { courseId: '4-20', courseName: '20.跨部门沟通与协作一情景模拟沙盘课' },
      { courseId: '4-21', courseName: '21.引爆变革一高管团队的变革管理' },
      { courseId: '4-22', courseName: '22.教练型高管一培育与辅导下属的绝招' },
      { courseId: '4-23', courseName: '23.最佳实践一组织发展与人才建设' },
      { courseId: '4-24', courseName: '24.决策者必修课一打造卓越领导力' },
      { courseId: '4-25', courseName: '25.从战略到执行' },
      { courseId: '4-26', courseName: '26.创新文化建立与实施' },],
      sign:false,
    }
  },
  mounted() {
    this.byEvents();
    this.isMobile()
    console.log(this.sign,89899)
  },
  methods: {
    byEvents() {
      this.dataList = [{
        id: '2-0',
        img: '/assets/ydguanwang/zhiyexingge.png',
        title: '职业性格测评',
        color: '#45ACA9',
        describle: '职业性格测评由五个大维度即驱动性、社交性、尽职性、宜人性和情绪性组成，每个维度下有4个子维度',
      },
      {
        id: '2-1',
        img: '/assets/ydguanwang/zhiyexingge.png',
        title: '职业驱动力测评',
        color: '#E99778',
        describle: '从成就需要、权力需要、亲和需要和外部需要四个大维度出发，定义了13个驱动因素来评估个体的激励偏好和倾向'
      },
      {
        id: '2-2',
        img: '/assets/ydguanwang/zhiyexingge.png',
        title: '心理健康测评',
        color: '#85C266',
        describle: '积极因素是指对个体心理健康产生积极影响的各种因素，消极因素是指对个体心理健康产生负面影响的各种因素'
      },
      {
        id: '2-3',
        img: '/assets/ydguanwang/zhiyexingge.png',
        title: '任职风险测评',
        color: '#6E76A5',
        describle: '基于情绪管理、人际交往及行为态度三个方面一共分为10个维度包括敌对性、冲动控制、悲观主义等等'
      },
      {
        id: '2-5',
        img: '../assets/ydguanwang/zhiyexingge.png',
        color: '#6194E4',
        title: '情境模拟测试',
        describle: '是一种通过模拟真实工作环境中的情境来评估个体能力、技能和决策过程的方法',
      },
      {
        id: '2-4',
        img: '/assets/ydguanwang/zhiyexingge.png',
        color: '#EDB646',
        title: '认知能力测评',
        describle: '基于多元智能理论，未来有道针对言语推理能力、空间智力、数字推理、逻辑推理、人际交往智力五个方面',
      },
      {
        id: '2-6',
        img: '/assets/ydguanwang/zhiyexingge.png',
        color: '#A066D6',
        title: '360多源反馈工具',
        describle: '通过与被评估对象有密切工作关系的人(包括自己、上级、 同事、下级等)对被评估人进行综合评估',
      },
      {
        id: '2-0',
        img: '/assets/ydguanwang/zhiyexingge.png',
        title: '职业性格测评',
        color: '#45ACA9',
        describle: '职业性格测评由五个大维度即 驱动性、社交性、尽职性、宜 人性和情绪性组成，每个维度 下有4个子维度',
      }
      ]

      let newDataList = [];
      let current = 0
      if (this.dataList && this.dataList.length > 0) {
        for (let i = 0; i <= this.dataList.length - 1; i++) {
          if (i % 4 !== 0 || i === 0) {	//数据处理成几张展示
            if (!newDataList[current]) {
              newDataList.push([this.dataList[i]])
            } else {
              newDataList[current].push(this.dataList[i])
            }
          } else {
            current++
            newDataList.push([this.dataList[i]])
          }
        }
      }
      this.dataList = [...newDataList]
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      if (key === '3') {
        if (this.$route.path !== '/inventory') {
          this.$router.push({ name: 'inventory', query: { key: key } })
        }

      } else if (key === '1') {
        console.log(this.$route.path, 9999)
        if (this.$route.path !== '/') {
          console.log(132)
          this.$router.push({ name: 'home', query: { key: key } })
        }
      } else if (key === '7-1') {
        if (this.$route.path !== '/aboutours') {
          this.$router.push({ name: 'aboutours', query: { key: key } })
        }
      } else if (key === '7-2') {
        if (this.$route.path !== '/aboutours') {
          this.$router.push({ name: 'aboutours', query: { key: key } })
        }
      } else if (key.substring(0, 1) === '4') {
        if (this.$route.path !== '/train') {
          this.$router.push({ name: 'train', query: { key: key } })
        }
      } else if (key.substring(0, 1) === '2') {
        if (this.$route.path !== '/products') {
          this.$router.push({ name: 'products', query: { key: key } })
        }
      }else if (key === '6') {
        console.log(this.$route.path, 9999)
        if (this.$route.path !== '/') {
          console.log(132)
          this.$router.push({ name: 'home', query: { key: key } })
        }
        this.gotoDetail()
      }

    },
    goLoginSystem() {
            window.open('https://talenpath.com/aitps')
        },
    // 跳转到工具详情
    goDetailTool(toolId) {
      this.$router.push({ name: 'products', query: { key: toolId } })

    },
    gotoDetail() {
      const h = this.$createElement;
      this.$notify({

        title: '待开发模块',

        message: h('i', { style: 'color: teal' }, '该模块正在建设中，敬请期待！！！')
      });
    },
    isMobile() {
				if (navigator.userAgent.match(
						/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					)) {
            this.sign = true
					return true; // 移动端
				} else {
          this.sign = false
					return false; // PC端
				}
			}

  }
}
</script>

<style lang="scss" scoped>
.submenu-items {
  width: 1500px;
  display: flex;
  flex-wrap: wrap;
  overflow-x: hidden;
  overflow-y: hidden;
}

.el-menu-item {
  width: 16%; /* 每个菜单项占据一半的宽度，两个并排 */
  text-align: center;
  // border: 1px solid black;
  // margin-left: 10px;
  // padding-left: 8px; 
}

/*去除导航菜单下划白线*/
.el-menu.el-menu--horizontal {
  border: none;
}

/* 标题颜色改变 */
>>>.el-menu--horizontal>.el-submenu .el-submenu__title {
  // width: 14.3rem;
  color: white;
}

/* hover颜色改变 */
>>>.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  color: rgb(102, 97, 97);
}

/* 消除动态添加的三角 */
>>>.el-icon-arrow-down:before {
  content: none;
}

/* 下拉宽度调整 */
>>>.el-menu-item {
  width: 5rem;
}



.home {
  .topBox {
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 27px 103px;
    // width: 80%;
    height: 105px;
    margin: auto;
    margin-top: -8px;
    // border: 1px solid black;
    justify-content: space-between;


    .ydlogoBox {
      width: 173px;
      height: 45px;
      margin-right: 30px;

      .ydlogoImg {
        width: 100%;
        height: 100%;
      }
    }

    .elmenuBox {
      width: 53%;
      // border: 1px solid black;
    }

    .phoneBox {
            display: flex;
            align-items: center;

            // border: 1px solid black;

            .phoneItem {
                width: 37px;
                height: 36px;

                .phoneImg {
                    width: 100%;
                    height: 100%;
                }
            }

            .zixunrexian {
                margin-left: 10px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 22px;
                color: #122C89;

                .haoma {
                    font-family: 540-CAI978;
                    font-weight: 400;
                    font-size: 24px;
                    color: #FE8129;
                }
            }

            .loginbutton {
                width: 120px;
                height: 50px;
                background: #122C89;
                border-radius: 25px;
                margin-left: 20px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 50px;
                cursor: pointer;
            }

        }
  }

  .tuceng {
    width: 100%;
    height: 600px;
    position: relative;

    .yuyuebtn {
      width: 235px;
      height: 65px;
      line-height: 65px;
      background: #FE8129;
      border-radius: 33px;
      position: absolute;
      margin: auto;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin-top: 480px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 26px;
      color: #FFFFFF;
      // background-color: #FE8129;

    }


    .tucengimg {
      width: 100%;
      // height: 100%;
    }

  }

  .centerBox {
    width: 100%;
    background-color: #F6F6F6;
    padding-bottom: 60px;



    .carouselBox {
      margin: 0 auto;
      width: 1200px;
      height: 420px;
      margin-top: 65px;
      // border: 1px solid black;


      .carousel {
        width: 100%;
        height: 420px;


        .el-car-item {
          width: 100%;
          height: 420px;
          display: flex;
          justify-content: space-between;

          .divSrc {
            width: 269px;
            height: 420px;
            background: #fff;
            margin-right: 46px;

            .img {
              width: 269px;
              height: 184px;
              background-color: #19D081;
              position: relative;
              .iconImg{
                width:50px;
                height: 60px;
                position: absolute;
                left: 0;
                top: 0;
                right: 0;
                bottom: 0;
                margin: auto;
              }
            }

            .title {
              width: 90%;
              // height: 80px;
              // line-height: 80px;
              margin: 0 auto;
              margin-top: 20px;
              text-align: center;
              font-size: 20px;
              font-weight: bold;
              color: #222222;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .describle {
              padding: 20px;
              text-align: left;
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 16px;
              color: #888888;
              height: 85px;
              // border: 1px solid black;
            }

            .gongjudetail {
              display: flex;
              align-items: center;
              justify-content: space-between;
              // border: 1px solid black;
              padding: 0 80px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 18px;
              color: #122C89;
              cursor: pointer;
              margin-top: 15px;

              .gongjuright {
                width: 20px;
                height: 20px;
              }
            }
          }


        }

      }
    }


    .cpandgjBox {
      width: 1200px;
      margin: auto;
      border: 1px solid transparent;

      .zizhiBox {
        display: flex;

        .weilaiImg {
          width: 333px;
          height: 320px;
        }

        .zizhiright {
          margin-left: 57px;
          text-align: left;

          .dizhi {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 26px;
            color: #122C89;
          }

          .jutijieshao {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 20px;
            color: #888888;
            line-height: 24px;
            margin-top: 30px;
            text-indent: 30px;
          }

        }
      }

      .cpBox {
        display: flex;
        align-items: center;
        justify-content: space-between;


        .cpItem {
          width: 367.7px;
          height: 244px;
          background: #FFFFFF;
          border-radius: 5px;

          .cpImg {
            width: 60px;
            height: 59px;
            margin-top: 20px;
          }

          .cpname {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 32px;
            color: #1B1B1B;
            margin-top: 25px;
            margin-bottom: 30px;
          }

          .cpdetail {
            width: 125px;
            height: 35px;
            background: #FFFFFF;
            border-radius: 18px;
            border: 2px solid #19D081;
            margin: auto;
            line-height: 35px;
            text-align: center;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #19D081;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            cursor: pointer;

            .jiantouImg {
              width: 7px;
              height: 12px;
            }
          }

        }
      }

      .cpTitle {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 48px;
        color: #000000;
        margin-top: 79px;
      }

      .cpmiaoshu {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 26px;
        color: #858585;
        margin-top: 33px;
        margin-bottom: 54px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .lineleft {
          width: 206.2px;
          height: 15px;
        }
      }
    }
  }

  .pandianBox {
    width: 100%;
    background-color: #ffffff;

    .banxinbox {
      width: 1200px;
      margin: auto;
      // border: 1px solid black;
      padding-bottom: 80px;

      .pandianItem {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .pandianxiang {
          width: 280px;

          .pandianImg {
            width: 280px;
            height: 186px;
          }

          .pandianTitle {
            height: 80px;
            text-align: center;
            font-family: Source Han Sans CN;
            font-weight: 500;
            line-height: 75px;
            font-size: 26px;
            color: #222222;
            background: #F6F6F6;
            margin-top: -5px;
          }
        }
      }

      .cpTitle {
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 48px;
        color: #000000;
        margin-top: 79px;
      }

      .cpmiaoshu {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 26px;
        color: #858585;
        margin-top: 33px;
        margin-bottom: 54px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .lineleft {
          width: 206.2px;
          height: 15px;
        }
      }
    }
  }

  .bottomBox {
    width: 100%;
    background-color: #313131;

    .beianBox {
      width: 1200px;
      margin: auto;
      margin-top: 60px;
      background-color: #313131;
      border-top: 2px solid #545454;
      padding: 30px 0;
      box-sizing: border-box;
      color: #F7F7F7;
    }

    .bottombanxin {
      width: 1200px;
      margin: auto;
      text-align: left;
      display: flex;
      justify-content: space-between;

      .bottomLeft {
        .talenpath {
          width: 247px;
          height: 45px;
          margin-top: 40px;
        }

        .erweima {
          width: 178px;
          height: 179px;
          margin-top: 40px;
        }

        .guanzhu {
          color: #F6F6F6;
          width: 178px;
          text-align: center;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 18px;
          color: #8D8D8D;
          margin-top: 15px;

        }
      }

      .bottomCenter {
        margin-top: 40px;
        color: #FFFFFF;
        // border: 1px solid #ffffff;
        width: 50%;

        .cepinggongju {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 22px;
          color: #F7F7F7
        }

        .gongjuDeBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
          // border: 1px solid #ffffff;
          // margin-top: 30px;

          .deItem {
            width: 30%;
            margin-top: 30px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #8D8D8D;
          }

        }
      }

      .bottomRight {
        margin-top: 40px;
        color: #FFFFFF;

        .cepinggongju {
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 22px;
          color: #F7F7F7;
        }

        .dianhuahaoma {
          font-family: 540-CAI978;
          font-weight: 400;
          font-size: 36px;
          color: #FE8129;
          margin-top: 29px;
        }

        .youxiang {
          font-family: Source Han Sans CN;
          font-weight: 500;
          font-size: 18px;
          color: #C5C5C5;
          margin-top: 29px;
        }
      }


    }
  }



}
</style>
